import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { ImportModelsByType } from '../import-models.map';
import { FormTemplatesByImportType } from '../form-templates.map';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { PageAction } from '../../../components/page-actions/page-actions.component';

@Component({
    selector: 'app-import-create',
    templateUrl: './import-create.component.html',
    styleUrls: ['./import-create.component.scss'],
    providers: [ImportService, ImportTypeService],
    standalone: false
})
export class ImportCreateComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  public pageActions: PageAction[];

  boundImport: Models.ImportBaseModel;
  title = '';

  isLoading: boolean;

  typeId;

  options = { hideFields: false };

  constructor(
    private router: Router,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
    private importService: ImportService,
    private importTypeService: ImportTypeService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    this.typeId = this.route.snapshot.params['type-id'];
    this.createPageActions();
    this.isLoading = true;
  }

  ngOnInit() {

    this.importTypeService.get(this.typeId).then(importTypeItem => {
      this.title = 'Create new Import: ' + importTypeItem.title;
      this.boundImport = <Models.ImportBaseModel>Models.ModelFactory.createModelInstanceByName(ImportModelsByType.get(importTypeItem.customId), { detail: {} });
      if (!this.boundImport) {
        this.isLoading = false;
        return;
      }
      this.boundImport.typeId = this.typeId;
      this.loadForm(importTypeItem.customId);
    });
  }

  loadForm(typeCustomId: string) {

    const formItem = FormTemplatesByImportType.get(typeCustomId) || DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundImport;
    (<FormComponent>componentRef.instance).options = this.options;
    this.isLoading = false;
  }

  onSave() {
    return this.boundImport.validate(true).then(result => {
      if (result.success) {
        return this.importService.create(<Models.Import>this.boundImport).then(createResult => {
          this.router.navigate(['imports/' + createResult.getId() + '/edit']);
        });
      } else {
        const message = this.filterFormResults(result);
        console.log(result);
        this.snackbar.error('Could not safe! Hint: ' + message);
      }
    });
  }

  private filterFormResults(result) {
    const error = result.results.filter(entry => {
      return !entry.success;
    });
    if (error && error[0].key) {
      if (error[0].results) {
        // the error has a sub Message from the validator
        return error[0].key + ' - ' + error[0].results[0].message;
      }
      return error[0].key + ' - ' + error[0].message;
    } else if (error[0].results) {
      // the error happens in a subModule
      return this.filterFormResults(error[0]);
    }
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'save',
        title: 'save',
        callback: () => {
          this.onSave();
        }
      }),
      new PageAction({
        icon: 'cancel',
        title: 'cancel',
        callback: () => {
          this.router.navigate(['import-types/', this.typeId]);
        }
      })
    ]
  }

}
